export interface AllowedTemplate {
  id: number;
  name: string;
}

/**
 * Forma (parcial) del tipo de proceso que entrega
 * `GET /maintainers-portal/academic-offer/admission-processes/form`.
 */
export interface TemplateSelectionProcessType {
  /**
   * Plantilla por defecto del tipo de proceso (`tp_process_type.templateId`).
   * Ojo: nada garantiza que este id esté también en `templates`.
   */
  templateId?: number | null;
  /** Plantillas permitidas para el tipo (`tp_process_type_template`). */
  templates?: AllowedTemplate[];
}

export interface TemplateSelection {
  /** Si se debe renderizar el selector de plantilla en el formulario. */
  showSelector: boolean;
  /** Plantilla preseleccionada; `null` es la opción "Ninguna". */
  selectedTemplateId: number | null;
}

/**
 * Decide qué plantilla queda preseleccionada al crear un proceso de admisión y
 * si el selector tiene sentido para el usuario:
 *
 * - varias plantillas          -> selector visible (default o "Ninguna")
 * - una plantilla sin default   -> selector visible, preseleccionada "Ninguna"
 * - una plantilla con default   -> sin selector, se asume el default
 * - sin plantillas              -> sin selector, se asume el default o "Ninguna"
 *
 * El selector se oculta cuando no hay nada real que elegir; en esos casos el
 * formulario igual envía `selectedTemplateId`.
 */
export function resolveTemplateSelection(
  processType?: TemplateSelectionProcessType | null,
): TemplateSelection {
  if (!processType) {
    return { showSelector: false, selectedTemplateId: null };
  }

  const templates = processType.templates ?? [];
  const selectedTemplateId = processType.templateId ?? null;

  const showSelector =
    templates.length > 1 ||
    (templates.length === 1 && selectedTemplateId === null);

  return { showSelector, selectedTemplateId };
}
